import { withFmaSliceSettings, fmaFieldParameters, fmaListingParameter, fmaFullFieldSettings, fmaCircularParameter } from './shared.js';

export default {
  label: 'Distortion Map', group: 'performance',
  description: 'Distortion magnitude and direction over a two-dimensional grid of field points.',
  settingsSchema: withFmaSliceSettings(fmaFullFieldSettings),
  parameters: [...fmaFieldParameters, fmaCircularParameter, fmaListingParameter],
  coverage: 'On a circular or rectangular field grid. Displacement is in lens units, or in milliradians for afocal systems; afocal systems need angular field coordinates. Values are displacements, not percentages, and are not calibrated. Field points CODE V skips are left empty. Calibrated and PSF-centroid distortion are not supported.',
} as const;
